// extracted by mini-css-extract-plugin
export var textInput = "_gv-0";